import React from 'react';
import './AppFooter.css';

const AppFooter = props => {
    return <div className='app-footer'>Preventomics ©{new Date().getFullYear()} Created by Eurecat ({window.screen.width} x {window.screen.height}) [React ver. {React.version}]</div>
}

export default AppFooter;